import React, { useEffect, useRef, useState } from 'react';
import { MapPin, Languages, Heart } from 'lucide-react';
import { profileData } from '../data/mock';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="about" ref={sectionRef} className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-4">
            About <span className="text-cyan-400">Me</span>
          </h2>
          <div className="w-20 h-1 bg-cyan-400 mx-auto mb-12"></div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-gray-300 text-lg leading-relaxed">
                {profileData.summary}
              </p>

              <div className="space-y-4 pt-6">
                <div className="flex items-start gap-3">
                  <MapPin className="text-cyan-400 flex-shrink-0 mt-1" size={20} />
                  <div>
                    <p className="text-gray-400 font-semibold">Location</p>
                    <p className="text-gray-300">{profileData.location}</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Languages className="text-cyan-400 flex-shrink-0 mt-1" size={20} />
                  <div>
                    <p className="text-gray-400 font-semibold">Languages</p>
                    <p className="text-gray-300">{profileData.languages.join(', ')}</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Heart className="text-cyan-400 flex-shrink-0 mt-1" size={20} />
                  <div>
                    <p className="text-gray-400 font-semibold">Interests</p>
                    <p className="text-gray-300">{profileData.interests.join(', ')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-slate-800 rounded-2xl p-8 shadow-xl border border-slate-700">
              <h3 className="text-2xl font-bold text-cyan-400 mb-6">Quick Facts</h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center py-3 border-b border-slate-700">
                  <span className="text-gray-400">Name</span>
                  <span className="text-white font-semibold">{profileData.name}</span>
                </div>
                <div className="flex justify-between items-center py-3 border-b border-slate-700">
                  <span className="text-gray-400">Role</span>
                  <span className="text-white font-semibold">{profileData.title}</span>
                </div>
                <div className="flex justify-between items-center py-3 border-b border-slate-700">
                  <span className="text-gray-400">Email</span>
                  <a href={`mailto:${profileData.email}`} className="text-cyan-400 hover:text-cyan-300 font-semibold">
                    Contact
                  </a>
                </div>
                <div className="flex justify-between items-center py-3">
                  <span className="text-gray-400">LinkedIn</span>
                  <a href={profileData.linkedin} target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 font-semibold">
                    Connect
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
